import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'
import { uniqBy } from 'lodash'
import { LogCollectiveUserPopover } from './LogCollectiveUserPopover'

const CollectiveLogDataOnDelegationsGranted: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnDelegationsGranted'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    isLast={isLast}
    bundle={bundledCollectiveLog}
    summaryActionText={`granted their voting delegations`}
    detailsActionText={log => {
      const uniqueDelegations = uniqBy(log.data.delegations, 'delegatee')
      return (
        <>
          {`granted voting delegations to `}
          {uniqueDelegations.map((delegation, i) => (
            <span key={`delegation_${i}`}>
              {i > 0 &&
                (i === uniqueDelegations.length - 1 ? (
                  <>&nbsp;&&nbsp;</>
                ) : (
                  <>,&nbsp;</>
                ))}
              <LogCollectiveUserPopover user={delegation.delegatee} />
            </span>
          ))}
        </>
      )
    }}
  />
)

export default CollectiveLogDataOnDelegationsGranted
